import { render } from "./UnsubscribeAction.vue?vue&type=template&id=0d104633&scoped=true"
import script from "./UnsubscribeAction.vue?vue&type=script&lang=ts"
export * from "./UnsubscribeAction.vue?vue&type=script&lang=ts"

import "./UnsubscribeAction.vue?vue&type=style&index=0&id=0d104633&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0d104633"

export default script